export const SERVICE_TYPE = {
  NEW: 'nuevo',
  ESIM: 'esim',
  MIGRATED: 'migrado',
  PORTABILITY: 'portabilidad',
} as const;

export type ServiceType = (typeof SERVICE_TYPE)[keyof typeof SERVICE_TYPE];
